import { WhatsApp } from "@mui/icons-material";

export default function Whatsapp() {
  const phoneNumber = "+6287828288989"; // Replace with actual number
  const message = encodeURIComponent(
    "Hi InMemoriam!. ada yang aku mau tanya nih",
  );
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: 30,
        right: 30,
        backgroundColor: "green",
        p: 4,
        borderRadius: "100px",
        zIndex: 999999999,
        width: 50,
        height: 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <WhatsApp fontSize="large" color="tertiary" />
    </a>
  );
}
